/**
 * Stable CSS class names for E2E — Order shipment status update modal / verification.
 */

export const UOSSU = {
    rootCard: 'order-detail-shipment-status-update__root-card',
    headerRow: 'order-detail-shipment-status-update__header-row',
    title: 'order-detail-shipment-status-update__title',
    inputButtonClose: 'order-detail-shipment-status-update-input--button-close',
    closeIcon: 'order-detail-shipment-status-update__close-icon',
    content: 'order-detail-shipment-status-update__content',
    divider: 'order-detail-shipment-status-update__divider',
    formColumn: 'order-detail-shipment-status-update__form-column',
    mainFormControl: 'order-detail-shipment-status-update__main-form-control',
    inputSelectNewStatus: 'order-detail-shipment-status-update-input--select-new-status',
    cancelReasonLabel: 'order-detail-shipment-status-update__cancel-reason-label',
    inputSelectCancelReason: 'order-detail-shipment-status-update-input--select-cancel-reason',
    inputTextCancelDetail: 'order-detail-shipment-status-update-input--text-cancel-detail',
    inputTextCrmCaseId: 'order-detail-shipment-status-update-input--text-crm-case-id',
    crmCaseIdHint: 'order-detail-shipment-status-update__crm-case-id-hint',
    inputButtonSave: 'order-detail-shipment-status-update-input--button-save',
    loadingState: 'order-detail-shipment-status-update__loading',
    errorState: 'order-detail-shipment-status-update__error',
} as const;

export const UOSSU_PDD = {
    inputTextDesi: 'order-detail-shipment-status-update-input--text-desi',
    inputTextPackageCount: 'order-detail-shipment-status-update-input--text-package-count',
} as const;

export const UOSSU_OTP = {
    verificationFormControl: 'order-detail-shipment-status-update__verification-form-control',
    verificationLegend: 'order-detail-shipment-status-update__verification-legend',
    verificationRadioGroup: 'order-detail-shipment-status-update-input--radio-group-verification',
    radioOtp: 'order-detail-shipment-status-update-input--radio-otp',
    radioIdentity: 'order-detail-shipment-status-update-input--radio-identity',
    otpSection: 'order-detail-shipment-status-update__otp-section',
    inputButtonResendOtp: 'order-detail-shipment-status-update-input--button-resend-otp',
    otpInputRow: 'order-detail-shipment-status-update__otp-input-row',
    inputTextOtpCode: 'order-detail-shipment-status-update-input--text-otp-code',
    inputButtonVerifyOtp: 'order-detail-shipment-status-update-input--button-verify-otp',
    identitySection: 'order-detail-shipment-status-update__identity-section',
    inputButtonIdentityVerify: 'order-detail-shipment-status-update-input--button-identity-verify',
    statusDivider: 'order-detail-shipment-status-update__verification-status-divider',
    statusRow: 'order-detail-shipment-status-update__verification-status-row',
    statusIconVerified: 'order-detail-shipment-status-update__verification-icon-success',
    statusIconFailed: 'order-detail-shipment-status-update__verification-icon-failed',
} as const;

export const uossuCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
